import { fetchGlossaryPage } from '@app/services/strapiServices'
import { useQuery } from '@tanstack/react-query'

export const useFetchGlossaryPage = () => {
  return useQuery({
    queryKey: ['glossaryPage'],
    queryFn: () => fetchGlossaryPage(),
  })
}
